module.exports = __webpack_public_path__ + "img/gartek-services-due-diligence-studies-rdisaster.b19e268b.png";